//import state from './moduleDashState.js'
import mutations from './moduleDashMutations.js'
import actions from './moduleDashActions.js'
import getters from './moduleDashGetters.js'
import getDefaultState from './moduleDashState'

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
